const locale = {
  FORM_VALIDATION_PLACEHOLDER_INPUT: '#',
  FORM_VALIDATION_FIELD_REQUIRED: 'Please enter your code',
  FORM_VALIDATION_MAXIMUM_CHARACTERS: 'The code must contain 6 digits',
  FORM_VALIDATION_FIRST_ATTEMPT: 'Incorrect code. You have 2 attempts left',
  FORM_VALIDATION_SECOND_ATTEMPT: 'Incorrect code. You have 1 attempt left',
  FORM_VALIDATION_THIRD_ATTEMPT: 'Incorrect code. You can try again in one hour',
};

export default locale;
